import { localeStore } from '@/shared/i18n/locale-store';
import type { Locale } from '@/shared/i18n/locales';

/** `ud` (units) is the stored default and is left out: "6", "1,5 L" / "1.5 L". */
export function formatQuantity(
  quantity: number | undefined,
  unit: string | undefined,
  locale: Locale = localeStore.read(),
): string {
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(quantity ?? 0);
  return `${number}${unit && unit !== 'ud' ? ` ${unit}` : ''}`;
}
